var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassButton",
    _vm._g(
      {
        staticClass: "ai-button",
        attrs: {
          label: _vm.label,
          type: _vm.type,
          size: _vm.size,
          disabled: _vm.disabled,
          leftIcon: _vm.leftIcon,
          dropdown: _vm.dropdown,
          loading: _vm.loading,
          submit: _vm.submit
        }
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }